/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import * as XLSX from "xlsx";
import { Col, pagination, Row, Table } from "antd";
import { onShowSizeChange, itemRender } from "../Pagination";
import MedicineForm from "./MedicineForm";
import { Link } from "react-router-dom";
import { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import {
  imagesend,
  plusicon,
  refreshicon,
  searchnormal,
} from "../imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useAuth } from "../../services/authentication_API/authService";
import { getmedicine } from "../../services/doctor/medicine/medicine";
import Loader from "../Loader";
// import { blogimg10, blogimg12, blogimg2, blogimg4, blogimg6, blogimg8 } from "../../components/imagepath";
const Medicines = () => {
    const { logout ,user,userData} = useAuth();
    const [refresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(false);


  
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        sidebar.classList.add("sidebar-doctor");
        sidebar.id = "menu-item1"; // Change ID if needed
      }
      document.body.classList.remove("expand-menu");
    
          document.body.classList.add("mini-sidebar");
    }, []);
      useEffect(() => {
        
          document.body.classList.remove("expand-menu");
    
          document.body.classList.add("mini-sidebar");
        
      }, [user]);
  
  const [datasource, setDatasource] = useState([]); // Start with empty array
  const [searchKeyword, setSearchKeyword] = useState("");
  
    const fetchMedicines = async () => {
      try {
        setLoading(true);
        const result = await getmedicine(searchKeyword,userData?.id);
        if (result.success) {
          // Format DosageTime if needed
          const formattedData = result.data.map((item, index) => ({
            ...item,
            id: item.id || `${Date.now()}-${index}`,
            DosageTime: Array.isArray(item.DosageTime)
              ? item.DosageTime
              : typeof item.DosageTime === "string"
              ? item.DosageTime.split(",").map((d) => d.trim())
              : [],
          }));
          
          setDatasource(formattedData);
        } else {
            // Optionally handle error
          setDatasource([]);
        }
      } catch (err) {
        // Optionally handle error
        setDatasource([]);
      }
      finally {
        setLoading(false);
      }
    };

   useEffect(() => {
  fetchMedicines();
}, [searchKeyword,refresh]);
  
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
  
        // Format DosageTime from comma-separated string to array
        const formattedData = data.map((item, index) => ({
          id: `${Date.now()}-${index}`, // unique id
          MedicinseName: item.MedicinseName,
          CompanyName: item.CompanyName,
          Contain: item.Contain,
          Type: item.Type,
          DosageTime: item.DosageTime.split(",").map((d) => d.trim()),
          Instruction: item.Instruction,
        }));
  
        // Append to existing data
        setDatasource((prev) => [...prev, ...formattedData]);
      };
      reader.readAsBinaryString(file);
    }
  };
  
  const [showModal, setShowModal] = useState(false);
const [modalType, setModalType] = useState("add"); // "add" or "edit"
const [selectedRecord, setSelectedRecord] = useState(null);

// Open modal for adding
const openAddModal = () => {
  setModalType("add");
  setShowModal(true);
};

// Open modal for editing
const openEditModal = (id) => {
  setModalType("edit");
  const record = datasource.find((item) => item.id === id);
  console.log("Selected Record for Edit:", record);
  setSelectedRecord(record); // Pass the record to be edited
  setShowModal(true);
};

  const columns = [
  {
    title: "Company Name ",
    dataIndex: "company_name",
    render: (text) => text ? text : "-",
  },
  {
    title: "Contain",
    dataIndex: "contain",
    render: (text) => text ? text : "-",
  },
  {
    title: "Name",
    dataIndex: "name",
    render: (text) => text ? text : "-",
  },
  {
    title: "Type",
    dataIndex: "type",
    render: (text) => text ? text : "-",
  },
  {
    title: "Dosage Time",
    dataIndex: "dosage_time",
    render: (text, record) => {
      const value = Array.isArray(record?.dosage_time)
        ? record.dosage_time.join(" , ")
        : record.dosage_time || "";
      return value && value.trim() !== "" ? value : "-";
    },
  },
  {
    title: "Instruction",
    dataIndex: "instruction",
    render: (text) => text ? text : "-",
  },
  {
    title: "",
    dataIndex: "FIELD8",
    render: (text, record) => (
      <>
        <div className="text-end">
          <div className="dropdown dropdown-action">
            <Link
              to="#"
              className="action-icon dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-end">
              <Link className="dropdown-item" 
              to="#"
              onClick={() => openEditModal(record.id)}>
                <i className="far fa-edit me-2" />
                Edit
              </Link>
              <Link
                className="dropdown-item"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#delete_patient"
                onClick={() => setSelectedRecord(record.id)}
              >
                <i className="fa fa-trash-alt m-r-5"></i> Delete
              </Link>
            </div>
          </div>
        </div>
      </>
    ),
  },
];
  return (
    <div>
      <Sidebar id="menu-item1" id1="menu-items1" activeClassName="medicines" />
      <>
        <div className="page-wrapper-doctor">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Doctor&apos;s Setting </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Medicines</li>
                  </ul>
                </div>
              </div>
            </div>  
            {/* /Page Header */}
            <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <Row className="mb-3">
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-3">
                        <div className="row align-items-center">
                          <div className="col-12">
                            <div className="doctor-table-blk">
                              <h3>Medicines List</h3>
                              <div className="doctor-search-blk d-flex flex-wrap justify-content-between align-items-center gap-2">
                                {/* Search */}
                                <div className="top-nav-search table-search-blk">
                                  <form>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search here"
                                      value={searchKeyword}
                                      onChange={(e) => setSearchKeyword(e.target.value)}
                                    />
                                    <Link
                                      className="btn"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        fetchMedicines();
                                      }}
                                    >
                                      <img src={searchnormal} alt="search" />
                                    </Link>
                                  </form>
                                </div>

                                {/* Buttons Group */}
                                <div className="add-group d-flex flex-wrap gap-2 align-items-center">
                                  <Link
                                    to="#"
                                    className="btn btn-primary add-pluss"
                                    onClick={() => {setShowModal(true),setSelectedRecord(null)} }
                                  >
                                    <img src={plusicon} alt="add" />
                                  </Link>

                                  <Link
                                    to="#"
                                    className="btn btn-primary doctor-refresh"
                                    onClick={()=>setRefresh(!refresh)}
                                  >
                                    <img src={refreshicon} alt="refresh" />
                                  </Link>

                                  {/* Import/Export Buttons */}
                                  {/* <div className="d-flex flex-wrap align-items-center gap-2">
                                    <label
                                      htmlFor="importExcel"
                                      className="btn btn-secondary"
                                      title="Import from Excel"
                                    >
                                      <FeatherIcon icon="upload" />
                                    </label>
                                    <input
                                      type="file"
                                      id="importExcel"
                                      accept=".xlsx, .xls"
                                      onChange={handleFileUpload}
                                      style={{ display: "none" }}
                                    />

                                    <a
                                      href="/sample_medicine.xlsx"
                                      download
                                      className="btn btn-outline-primary"
                                      title="Download Sample File"
                                    >
                                      <FeatherIcon icon="download" />
                                    </a>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /Table Header */}

                      {/* Responsive Table */}
                      <div className="table-responsive">
                        {loading ? <Loader/> : 
                        <Table
                          pagination={{
                            total: datasource.length,
                            showTotal: (total, range) =>
                              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                            onShowSizeChange: onShowSizeChange,
                            itemRender: itemRender,
                            style: { paddingRight: "14px" },
                          }}
                          columns={columns}
                          dataSource={datasource}
                          rowSelection={rowSelection}
                          rowKey={(record) => record.id}
                        />}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>

          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"setShowModal
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button type="submit" className="btn btn-danger">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MedicineForm        
        show={showModal}
        onHide={() =>{ setShowModal(false), setModalType("add"),setSelectedRecord(null)}}
        refresh={()=> setRefresh(!refresh)}
        type={modalType}
        record={selectedRecord}
      />
      </>
    </div>
  );
};

export default Medicines;
